// Firebase App Check (reCAPTCHA Enterprise), project youth-ncert.
// Adds an X-Firebase-AppCheck token to the OTP requests so the backend can
// tell real website visitors from scripts calling the API directly.
import { initializeApp, getApps } from "firebase/app";
import {
  initializeAppCheck,
  ReCaptchaEnterpriseProvider,
  getToken,
} from "firebase/app-check";

// youth-ncert Web app config (Firebase Console > Project settings), set in .env / Vercel
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

let appCheck = null;
let warnedMissingConfig = false;

// Initialise App Check once. Returns null when the env config is missing.
export const getAppCheck = () => {
  if (typeof window === "undefined") return null;
  if (appCheck) return appCheck;
  if (!firebaseConfig.apiKey || !firebaseConfig.appId || !recaptchaSiteKey) {
    if (!warnedMissingConfig) {
      console.warn("App Check is not configured: missing Firebase or reCAPTCHA env values");
      warnedMissingConfig = true;
    }
    return null;
  }

  try {
    const app = getApps()[0] ?? initializeApp(firebaseConfig);
    if (process.env.NODE_ENV !== "production") {
      // Local testing only: prints "App Check debug token" in the browser console
      window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
    }
    appCheck = initializeAppCheck(app, {
      provider: new ReCaptchaEnterpriseProvider(recaptchaSiteKey),
      isTokenAutoRefreshEnabled: true,
    });
  } catch (e) {
    console.log("App Check init failed :- ", e);
    appCheck = null;
  }
  return appCheck;
};

// Headers for an OTP request. Never throws: without a token the request goes out as before.
export const appCheckHeader = async () => {
  try {
    const ac = getAppCheck();
    if (!ac) return {};
    const { token } = await getToken(ac, false);
    return { "X-Firebase-AppCheck": token };
  } catch {
    return {};
  }
};
